module.exports = __webpack_public_path__ + "img/jinyu.fb0c69ac.png";